//get wix user data to check wix user logged in

import { fetch } from 'wix-fetch';
import wixLocation from 'wix-location';

export function getUserDetails() {
	return fetch(wixLocation.baseUrl + "/_api/wix-html-login-webapp/user/getUserDetails", { "method": "get" })
		.then((httpResponse) => {
			if (httpResponse.ok) {
				return httpResponse.json();
			}
			return Promise.reject("Fetch did not succeed");
		})
		.then((json) => {
			if (json.success && json.payload && json.payload.guid) {
				return { guid: json.payload.guid, email: json.payload.email };
			}
		})
		.catch((err) => {
			console.error("could not get user details");
		});
}



